import React from "react";
import Section from "../Section/section";
import "./whoWeAre.scss";
import moneyFormatter from "money-formatter";

const WhoWeAre = ({ campaignData }) => (
  <Section name="who-we-are" header="Who we are">
    <div className="width-75">
      <p>We are Barclays, a global bank with customers in 40 countries around the world. We don’t have branches, but we
        do have 85,000 employees dedicated to helping our customers borrow, invest, move, and protect their money, every
        day.</p>
      <p>We offer a fully digital experience, which means our customers’ finances are always available to them, anytime
        and anywhere. Whether it’s credit cards, savings, CDs, or loans, we offer simple tools that make managing your
        finances easy. We also promise that a real person will always be available for those times when you need a
        little extra help.</p>
      <p className="mb-5">Barclays isn’t like other banks. We are here to make banking work for our customers, and
        provide an experience
        that helps them succeed. With great rates, better rewards, and clear financial management, we give our customers
        more time to focus on what’s important to them.
      </p>
      <p id="apr-foot-note">
        1. Annual Percentage Rates (APR) range from {campaignData.minApr}% to {campaignData.maxApr}% and will be determined based on your
        creditworthiness and loan term. Loan amounts range from {moneyFormatter.format('USD', campaignData.minLoanAmount, 0)} to {moneyFormatter.format('USD', campaignData.maxLoanAmount, 0)}. Loan terms can range from 36 months
        to 60 months. <a id="backToContent" href="#value-statement" aria-label="Back to content">↵</a>
      </p>
      <hr/>
      <div className="d-flex align-items-center">
        <span className="bcus-logo-eagle mx-2"/>
        <span>Barclays US – <span className="font-italic text-muted">backed by Barclays.</span></span>
      </div>
    </div>
  </Section>
);

export default WhoWeAre;
